const state = {
  all: [],
  order: {},
  newFCMNotification: false,
  isLoading: false,
  isOrderProcessing: false,
  isOrderLoading: false,
  listStatus: 'all',
  materials: null,
  isMaterialLoading: false,
  lr: null,
  isLrLoading: false,
  changeTruckComments: null,
  currentDepot: null,
  currentDepotConfiguration: null,
  isPaginating: false,
  isUploading: false,
  hyperTrack: {},
  count: {},
  latestUpdated: null,
  locationData: null,
  isEmptyPaginate: false,
  grn: [],
  grnLoading: false,
  materialHeaders: {},
  canShowSaveGRN: false,
  userEdited: false,
  warnedOnce: false,
  isGlobalFilter: false,
  globalSearchQ: '',
  courierTransporters: [],
  filter: {
    page: 1,
    category: 0,
    depot_id: null,
    order_type: null,
    movement: null,
    delivery_type: null,
    status: null,
    approval_status: null,
    start: null,
    end: null,
    order_number: null,
    transporter: null,
    vehicle_number: null,
    lr_number: null,
    destination: null,
    consignee: null,
    material_ref_id: null,
  },
  filter_term_tags: [],
  filter_search_term: [],
  grnDetails: [],
  trackingList: [],
  consignmentTrackingList: [],
  isConsignmentTrackLoading: false,
  documentation: {
    packing_list: [],
    commercial_invoice: [],
    bill_of_lading: [],
  },
  returnMaterialDetails: {},
  returnMaterialWarnedOnce: false,
  isApprovalDataLoading: false,

  // packing related variables
  deliverySummary: [],
  subDeliveryPage: 1,
  isSubDeliveryLoading: false,
  subDeliveryDetails: [],
  hasEmptySubDeliveryList: false,

  // delivery numbers in document tab
  deliveryNumberDetails: [],
  invoiceDetails: {},
  integrationTimeLine: [],
  reconciliation: {},
  isReconciliationLoading: false,
  payAnomalyData: [],
  payAnomalyLoading: false,
  hasEmpty: false,
  isMultiLrLoading: false,
};

export default state;
